// material-ui
import { Grid, Typography, Stack, Link } from '@mui/material';

// project imports
import MainCard from 'components/cards/MainCard';
import Main from 'views/layouts/Main/Main'; //
import { SimUnorderedList, SimSection, SimSectionHeader, StaticSectionWrapper } from 'components/StaticSections';

const GrievanceView = () => {
	return (
		<Main>
			<StaticSectionWrapper>
				<Grid container justifyContent='center' spacing={1}>
					<SimSectionHeader title='Grievance Policy' />
					<Grid item xs={12}>
						<MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
							<Stack spacing={2} sx={{ textAlign: 'left' }}>
								<SimSection title='THIS POLICY DESCRIBES HOW TO COMPLAIN ABOUT MEDICAL TREATMENT AND SERVICES PROVIDED AND HOW TO FILE A GRIEVANCE. PLEASE REVIEW IT CAREFULLY.'>
									<Typography textAlign={'justify'}>
										SIM SOULS GROUP LLC’s and SIM SOULS INSTITUTE 1 INC’s (“SimSouls”, “we” or “us”)
										is committed to the quality and satisfaction of services provided for patients
										receiving medical treatment and services. We acknowledged that differences or
										disagreements may arise during the medical treatment process and wishes to
										resolve such instances in an expeditious and prudent manner for the benefit of
										the patient and their parents, legal guardians, or authorized representative
										(collectively the “representatives”).
									</Typography>
									<Typography textAlign={'justify'}>
										Any patient receiving medical treatment and services, including their persons,
										will be informed of and may use the patient grievance process. The patient
										grievance process is in place to ensure fair hearing of complaints and quick
										resolution of problems regarding medical treatment and services provided,
										without fear of reprisal on the part of persons receiving services, their
										families, etc. Additionally, a copy of this Patient Grievance Policy (the
										“Policy”) is posted in a public area easily accessible at the clinic.
									</Typography>
								</SimSection>

								<SimSection title='I. HOW TO COMPLAIN ABOUT MEDICAL TREATMENT AND SERVICES'>
									<Typography textAlign={'justify'}>
										To complain, recommend, or provide an opinion regarding the medical treatment
										and services received, please speak with the Clinic Manager at the clinic in
										which the patient received services. If the complaint cannot be resolved with
										the Clinic Manager, the patient or representative (collectively the
										“Complainant”) can file a formal grievance with SimSouls. If a Complainant
										articulates a grievance or poses questions about filing a grievance, the Clinic
										Manager is responsible to provide the Complainant with the name and availability
										of the Patient Rights Representative.
									</Typography>
									<Typography textAlign={'justify'}>
										The Chief Clinical Officer (“CCO”) will act as the primary Patient Rights
										Representative (“Representative”), who has the responsibility for overseeing the
										grievance process, and the Chief Operating Officer (“COO”) as the secondary
										Representative. The Representatives will provide such assistance as may be
										necessary for a Complainant to file a grievance. Should either Representatives
										be the subject of a grievance, the Director of Applied Behavior Analysis and the
										Chief Compliance Officer will function as alternate Representatives and will
										work with the Complainant to explain and aid with filing a grievance.
									</Typography>
									<Typography textAlign={'justify'}>
										The Representatives will be available during routine clinic operating hours,
										8:30 AM to 5:00 PM, to meet with any Complainant desiring to initiate a
										grievance. If the Representative is unavailable when a Complainant makes contact
										to initiate a grievance, either the Representative or, in the case of extended
										unavailability, the Representative will contact the Complainant within three (3)
										business days.
									</Typography>
									<Typography textAlign={'justify'}>
										Upon expressing to the Representatives, a desire to file a grievance, the
										Complainant is entitled to a private conference with the Representatives. Such
										conference shall be scheduled by the Representatives within three (3) business
										working days of contacting the Complainant. During this conference, the
										Representatives will provide a copy of this Policy and will review and explain
										said Policy. This Policy serves as notification that all grievances must be
										submitted in writing, and that the Representatives are available to assist the
										complainant in preparing a written grievance.
									</Typography>
									<Typography textAlign={'justify'}>
										A written decision including the rationale by the Representatives will be
										submitted to the Complainant within thirty (30) days after filing a grievance.
										If the Complainant does not agree with the decision of the Representatives, the
										Complainant may file a grievance with the State’s Department of Health Services
										to review the complaint. The State’s recommendation will constitute the final
										recommendation to all parties.
									</Typography>
								</SimSection>

								<SimSection title='II. HOW TO COMPLETE A FORMAL WRITTEN GRIEVANCE'>
									<SimUnorderedList
										title='All formal written grievances are to be submitted to the Representative noted in Section V below and should include the following information:'
										list={[
											'Date, time, and location the grievance or alleged violation occurred.',
											'Name or description of individuals involved in the incident or situation being grieved.',
											'A brief narrative of the incident or grievance.',
											'The name of the Complainant filing the grievance.',
											'The date of grievance filing is verified by the signatures of both the Complainant and the Representatives. If third-party files the grievance on behalf of the Complainant, the signature of that third-party should also be included with the date of grievance filing.'
										]}
									/>
									<SimUnorderedList
										title='Following receipt of a grievance from a Complainant, within three (3) business working days, the Representative will acknowledge receipt of the grievance in writing to the Complainant responsible for the filing. The written acknowledgment will include, at minimum, the following information:'
										list={[
											'Date the grievance was received.',
											'Summary of the grievance.',
											'Overview of the grievance investigation process including a timetable for completing the investigation and notifying the Complainant of the proposed resolution.',
											'Contact name, address, and telephone number of the Representative.'
										]}
									/>
									<Typography textAlign={'justify'}>
										In addition to this initial acknowledgment, written notification, and
										explanation of the disposition of any grievance will be supplied to the
										Complainant at any stage of the grievance process within the time frames
										specified in this Policy.
									</Typography>
									<Typography textAlign={'justify'}>
										The Representative shall investigate the grievance and provide the Complainant
										with a written decision including the summary of any findings and the proposed
										resolution within thirty (30) days after formally filing a grievance. A copy of
										any such findings will also be provided to the Chief Executive Officer (“CEO”).
										Any extenuating circumstances indicating the extension of this period must be
										documented in a written notice of such an extension and provided to the
										Complainant.
									</Typography>
									<Typography textAlign={'justify'}>
										If the proposed resolution is not satisfactory to the Complainant, they,
										accompanied by the Representative, will meet with the CEO to promote resolution
										of the grievance. Such meeting must be requested within ten (10) business
										working days of the notification of findings and will be scheduled within five
										(5) business working days of the request. Following this meeting, the CEO will
										investigate the grievance and will render a decision within five (5) business
										working days from the time of the meeting. The CEO’s decision will constitute
										the final recommendation to all parties.
									</Typography>
									<Typography textAlign={'justify'}>
										If the Complainant does not agree with the decision of the CEO, the Complainant
										may file a grievance with the Department of Human and Health Services for
										Kentucky and Ohio or the Attorney General’s Office for Indiana to review the
										complaint. The state’s recommendation will constitute the final recommendation
										to all parties.
									</Typography>
								</SimSection>

								<SimSection title='III. ACTION'>
									<Typography textAlign={'justify'}>
										If the resolution of the grievance involves the termination of services, or to
										provide, change, reduce or deny services set forth in the Complainants plan of
										care, a written notice shall be provided to the Complainants at least ten (10)
										business days prior to the effective date. All written reports of the grievance
										will be made part of the patient administrative record.
									</Typography>
								</SimSection>
								<SimSection title='IV. NON-RETALIATION'>
									<Typography textAlign={'justify'}>
										If a grievance is filed, it is the strict policy of SIMSOULS that the grievance
										will not result in retaliation toward the Complainant, create a barrier to the
										provision of medical treatment and services, or the refusal to provide the
										availability or assistant of the Complainant seeking an advocate.
									</Typography>
								</SimSection>
								<SimSection title='V. CHANGES TO THIS POLICY'>
									<Typography textAlign={'justify'}>
										The Company may change the Terms from time to time as required by evolving
										business needs. If changes are made, please note that it may take up to 30
										business days before new practices are implemented. The current revision date
										will always be designated within the Terms. Check this page periodically if you
										would like to monitor changes. You are responsible for periodically visiting our
										Website and this Policy to check for any changes.
									</Typography>
								</SimSection>
								<SimSection title='VI. CONTACT INFORMATION'>
									<Typography textAlign={'justify'}>
										If you have any questions, comments or concerns about this policy or your
										interactions with SimSouls, please email us at{' '}
										<Link href='#' underline='none'>
											compliance@simsouls.com
										</Link>{' '}
										or call us at +1.469.269.0515.
									</Typography>
								</SimSection>
								<SimSection title='VII. EFFECTIVE DATE'>
									<Typography textAlign={'justify'}>
										This Policy was effective on 06/20/2022.
									</Typography>
								</SimSection>
							</Stack>
						</MainCard>
					</Grid>
				</Grid>
			</StaticSectionWrapper>
		</Main>
	);
};

export default GrievanceView;
